import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { ToastCustomActions } from '@shared/components/toast-custom/toast-custom.config';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { THEMES } from '@shared/config';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[custom-toastr]',
  templateUrl: 'toast-custom.component.html',
  styleUrls: ['./toast-custom.component.scss'],
  standalone: false,
})
export class ToastCustomComponent extends Toast {
  public readonly LocalStorage = LocalStorageService;
  public readonly THEMES = THEMES;

  public doAction(event: Event, action: ToastCustomActions) {
    event.preventDefault();
    this.toastPackage.triggerAction(action);
  }

  public dismiss() {
    this.toastrService.clear(this.toastPackage.toastId);
  }
}
